module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.ed7150fd.jpg";